/**
 * What every onboarding route shows while the deployment's `onboarding` is
 * `closed` — production's state until M4 (#158).
 *
 * A courtesy, not a control. The control is the gate's kill switch,
 * `KARVSTOKK_SPONSORSHIP=halted`, which refuses the sponsored path whatever
 * this page shows; nothing here should read as if it were the thing keeping
 * anyone out.
 */
export function NotOpenYet() {
  return (
    <main>
      <h1>Karvstokk is not open yet</h1>
      <p>Creating a Profile isn't available here yet.</p>
    </main>
  );
}
